import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { formatDate } from '../../../../../utils/reviews';

export interface CompanyAnswerProps {
    answer: string;
    hotelName: string;
    creationDate: string;
}

interface StyledCompanyAnswerProps
    extends JSSClassesProps<ComponentJSSClasses>,
        CompanyAnswerProps {}

export function CompanyAnswer(props: StyledCompanyAnswerProps) {
    const [showMoreBtn, setShowMoreBtn] = useState<boolean>(false);
    const [isShowDetailReviewText, setShowDetailText] = useState<boolean>(false);
    const { classes, answer, hotelName, creationDate } = props;
    const answerRef = useRef<HTMLParagraphElement>(null);

    useEffect(() => {
        if (answerRef?.current) {
            if (answerRef.current.scrollHeight > answerRef.current.clientHeight) {
                setShowMoreBtn(true);
            }
        }
    }, [answer, answerRef]);

    const switchShowText = () => setShowDetailText((st) => !st);

    return (
        <div className={classes.container}>
            <div className={classes.answerArrow} />
            <div className={`${classes.answerContent} ${isShowDetailReviewText ? classes.reviewTextDetail : ''}`}>
                <div className={classes.answerContentWrapper}>
                    <div className={`${classes.answerContentInner} ${isShowDetailReviewText ? classes.reviewTextDetail : ''}`}>
                        <p className={classes.answerText} ref={answerRef}>
                                {answer}
                        </p>
                    </div>
                    {showMoreBtn && (
                        <button className={classes.moreInfoButton} onClick={switchShowText} type="button">
                            {isShowDetailReviewText ? 'Свернуть' : 'Читать далее'}
                        </button>
                        )}
                </div>
                <div className={classes.answerInfo}>
                    <p className={classes.companyName}>{hotelName}</p>
                    {creationDate &&
                    <p className={classes.answerCreated}>
                        Дата ответа: {formatDate(creationDate)}
                    </p>}
                </div>
            </div>
        </div>
    );
}
